type HighlightedTextProps = {
  text: string;
};

export const HighlightedText = ({ text }: HighlightedTextProps) => {
  // Split on <highlight> and </highlight>
  const parts = text.split(/<\/?highlight>/);

  return (
    <span>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark key={i} className="bg-highlight-bg font-bold">
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </span>
  );
};
